// The console's entry: a connection over the websocket URL the platform
// profile names, with its sentinel, placed by the callout under the signed-in
// person's role, and checked against the tenant's account when a tenant is
// named (02-DESIGN/03-console/01-the-console.md § signing in; 03-signing-in.md
// § connecting).
import { wsconnect } from "@nats-io/nats-core";
import { checkPlacement, Client, parseSentinel } from "./connect.js";
/**
 * connectBrowser connects over the platform profile's websocket URL with its
 * sentinel and the connect token, and when a tenant is named checks that the
 * connection was placed in its account, closing it otherwise.
 */
export async function connectBrowser(profile, o) {
    const sentinel = parseSentinel(profile.sentinel);
    const client = new Client({
        sentinel,
        lane: o.lane,
        tenant: o.tenant?.slug,
        plane: o.plane,
        inbox: o.inbox,
        credential: o.credential,
        name: o.name,
        onError: o.onError,
    });
    const nc = await client.connect(wsconnect, profile.websocket_url, o.extra);
    if (o.tenant) {
        try {
            await checkPlacement(nc, o.tenant.account);
        }
        catch (err) {
            await nc.close();
            throw err;
        }
    }
    return nc;
}
//# sourceMappingURL=browser.js.map